const { PRECONFIGURATION_CAR_IMAGES } = require("../../constants");

const getCarImagePath = preconfigurationId => {
  const carImage = Object.values(PRECONFIGURATION_CAR_IMAGES).find(value =>
    value.includes(preconfigurationId)
  );

  if (!carImage) {
    return `/images/preconfigs/front-default.png`;
  }

  return `/images/preconfigs/${preconfigurationId}/${carImage}.png`;
};

module.exports = { getCarImagePath };
